<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="estimateMain">
          <project-asset v-on:project-changed="onProjectChange" v-on:vessel-changed="onVesselChange"></project-asset>
          <v-card id="estimatesCard">
            <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t("nav.estimates") }}</v-card-title>
            <v-data-table id="estimateTable" :headers="headers" :items="items" :items-per-page="-1" class="elevation-0">
              <template v-for="header in headers" v-slot:[`header.${header.value}`]>
                <v-tooltip bottom v-if="header.tooltip" :key="header.value">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <span>{{ header.text }}</span>
                    </div>
                  </template>
                  <span>{{ header.tooltip }}</span>
                </v-tooltip>
                <span v-else :key="header.tooltip">{{ header.text }}</span>
              </template>

              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.estimateID }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>{{ props.item.op }}</td>
                  <td>{{ props.item.td }}</td>
                  <td>{{ props.item.ed }}</td>
                  <td>{{ props.item.od }}</td>
                  <td>{{ props.item.sh }}</td>
                  <td>{{ props.item.efficiency }}</td>
                  <td>{{ props.item.techncialEfficiency }}</td>
                  <td>{{ props.item.sailingEmpty }}</td>
                  <td>{{ props.item.loadingFromShore }}</td>
                  <td>{{ props.item.freeLaying }}</td>
                  <td>{{ props.item.sLBJetting }}</td>
                  <td>{{ props.item.sLBTrenching }}</td>
                  <td>{{ props.item.layingWithCIS }}</td>
                  <td>{{ props.item.sailingLoaded }}</td>
                  <td>{{ props.item.pLBurialJetting }}</td>
                  <td>{{ props.item.pLBurialTrenching }}</td>
                  <td>{{ props.item.massFlowExcavation }}</td>
                  <td>{{ props.item.concreteMattInstallation }}</td>
                  <td>{{ props.item.rOVOps }}</td>
                  <td>{{ props.item.pretrenching }}</td>
                  <td>{{ props.item.backfilling }}</td>
                  <td>{{ props.item.boulderClerance }}</td>
                  <td>{{ props.item.pLGR }}</td>
                  <td>{{ props.item.routeClearance }}</td>
                  <td>{{ props.item.seaTrials }}</td>
                  <td>{{ props.item.pLBJetting2 }}</td>
                  <td>{{ props.item.pLBJetting3 }}</td>
                  <td>{{ props.item.landing }}</td>
                  <td>{{ props.item.cableTesting }}</td>
                  <td>{{ props.item.jointing }}</td>
                  <td>{{ props.item.othersOP }}</td>
                  <td>{{ props.item.fuelCons }}</td>
                  <td>{{ props.item.OilCons }}</td>
                  <td>{{ props.item.FWCons }}</td>
                  <td style="text-align: left">
                    {{ props.item.projectName }}
                  </td>
                  <td style="text-align: left">
                    {{ props.item.vesselName }}
                  </td>
                  <td>
                    <v-btn id="btnDel" color="primary" x-small fab outlined elevation="1" @click="deleteItemConfirm(props.item)">
                      <v-icon small color="primary">
                        mdi-delete
                      </v-icon> </v-btn
                    >&nbsp;
                    <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" :disabled="props.item.isDeleted === true" @click="editItem(props.item)">
                      <v-icon small color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-dialog v-model="dialogTabs" max-width="75%">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-form @submit.prevent="submit" ref="form">
                  <v-tabs class="mb-2 mt-4 pa-2" color="primary" grow>
                    <v-tab>{{ $t("est.tab1") }}</v-tab>
                    <v-tab>{{ $t("est.tab2") }}</v-tab>
                    <v-tab>{{ $t("est.tab3") }}</v-tab>
                    <v-tab>{{ $t("est.tab4") }}</v-tab>
                    <v-tab>{{ $t("est.tab5") }}</v-tab>
                    <v-tab-item>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field v-model="editedItem.estimateID" :rules="[() => !!editedItem.estimateID || requiredMessage]" required>
                                <template v-slot:label>
                                  <v-icon color="red" x-small>mdi-asterisk</v-icon>
                                  {{ $t("nav.estimateId") }}
                                </template></v-text-field
                              >
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-select :rules="[() => !!editedItem.projectId || requiredMessage]" required :items="projects" item-text="Name" item-value="Id" v-model="editedItem.projectId" :readonly="editedIndex != -1" @change="onDlgProjectChange"
                                ><template v-slot:label>
                                  <v-icon color="red" x-small>mdi-asterisk</v-icon>
                                  {{ $t("common.projectName") }}
                                </template>
                              </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-select :rules="[() => !!editedItem.vesselId || requiredMessage]" required class="form-control" :items="projectVessels" item-text="Name" item-value="Id" v-model="editedItem.vesselId" :readonly="editedIndex != -1" @change="onDlgVesselChange">
                                <template v-slot:label>
                                  <v-icon color="red" x-small>mdi-asterisk</v-icon>
                                  {{ $t("nav.vessels") }}
                                </template>
                              </v-select></v-col
                            >
                            <v-col cols="12">
                              <v-text-field v-model="editedItem.description" :rules="[() => !!editedItem.description || requiredMessage]" required>
                                <template v-slot:label>
                                  <v-icon color="red" x-small>mdi-asterisk</v-icon>
                                  {{ $t("column.description") }}
                                </template></v-text-field
                              >
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="2" md="2">
                              <positive-numeric-input v-model="editedItem.op" label="est.op"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                              <positive-numeric-input v-model="editedItem.td" label="est.td"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                              <positive-numeric-input v-model="editedItem.ed" label="est.ed"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                              <positive-numeric-input v-model="editedItem.od" label="est.od"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                              <positive-numeric-input v-model="editedItem.sh" label="est.sh"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <positive-numeric-input v-model="editedItem.efficiency" label="est.Efficiency"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <positive-numeric-input v-model="editedItem.techncialEfficiency" label="est.TechncialEfficiency"> </positive-numeric-input>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.sailingEmpty" label="est.E_SailingEmpty"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.loadingFromShore" label="est.E_LoadingFromShore"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.freeLaying" label="est.E_FreeLaying"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.sLBJetting" label="est.E_SLBJetting"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.sLBTrenching" label="est.E_SLBTrenching"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.layingWithCIS" label="est.E_LayingWithCIS"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.sailingLoaded" label="est.E_SailingLoaded "> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.pLBurialJetting" label="est.E_PostLayingBurialJetting"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.pLBurialTrenching" label="est.E_PostLayingBurialTrenching"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.massFlowExcavation" label="est.E_MassFlowExcavation"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.concreteMattInstallation" label="est.E_ConcreteMattressesInstallation"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.rOVOps" label="est.E_ROVOps"> </positive-numeric-input>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.pretrenching" label="est.E_Pretrenching"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.backfilling" label="est.E_Backfilling"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.boulderClerance" label="est.E_BoulderClerance"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.pLGR" label="est.E_PLGR"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.routeClearance" label="est.E_RouteClearance"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.seaTrials" label="est.E_SeaTrials"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.pLBJetting2" label="est.E_PLBJetting2"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.pLBJetting3" label="est.E_PLBJetting3"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.landing" label="est.E_Landing"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.cableTesting" label="est.E_CableTesting"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.jointing" label="est.E_Jointing"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                              <positive-numeric-input v-model="editedItem.othersOP" label="est.E_OthersOP"> </positive-numeric-input>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="4" md="4">
                              <positive-numeric-input v-model="editedItem.fuelCons" label="est.FuelConsumption"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <positive-numeric-input v-model="editedItem.OilCons" label="est.OilConsumption"> </positive-numeric-input>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <positive-numeric-input v-model="editedItem.FWCons" label="est.FWConsumption"> </positive-numeric-input>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-tab-item>
                  </v-tabs>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{ $t("common.cancel") }}</v-btn>
                  <v-btn color="primary" text @click="save" :disabled="!formIsValid">{{ $t("common.save") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct" style="padding-left: 15px">
              <v-fab-transition>
                <v-btn id="btnAddactivityType" color="primary" dark small left fab @click="createItemDTabs()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import ProjectAsset from "../common/ProjectAsset";

export default {
  components: {
    "project-asset": ProjectAsset,
  },
  data() {
    return {
      dialog: false,
      dialogTabs: false,
      dialogPanels: false,
      isValidNumber: true,
      requiredMessage: this.$t("common.required"),
      headers: [
        {
          text: this.$t("nav.estimateId"),
          align: "left",
          sortable: true,
          value: "estimateID",
          tooltip: this.$t("est.tooltip.estimateId"),
        },
        {
          text: this.$t("column.description"),
          align: "center",
          value: "description",
          tooltip: this.$t("est.tooltip.description"),
        },
        { text: this.$t("est.op"), align: "center", value: "op", tooltip: this.$t("est.tooltip.op") },
        { text: this.$t("est.td"), align: "center", value: "td", tooltip: this.$t("est.tooltip.td") },
        { text: this.$t("est.ed"), align: "center", value: "ed", tooltip: this.$t("est.tooltip.ed") },
        { text: this.$t("est.od"), align: "center", value: "od", tooltip: this.$t("est.tooltip.od") },
        { text: this.$t("est.sh"), align: "center", value: "sh", tooltip: this.$t("est.tooltip.sh") },
        {
          text: this.$t("est.Efficiency"),
          align: "center",
          value: "efficiency",
          tooltip: this.$t("est.tooltip.Efficiency"),
        },
        {
          text: this.$t("est.TechncialEfficiency"),
          align: "center",
          value: "techncialEfficiency",
          tooltip: this.$t("est.tooltip.TechncialEfficiency"),
        },
        {
          text: this.$t("est.E_SailingEmpty"),
          align: "center",
          value: "sailingEmpty",
          tooltip: this.$t("est.tooltip.E_SailingEmpty"),
        },
        {
          text: this.$t("est.E_LoadingFromShore"),
          align: "center",
          value: "loadingFromShore",
          tooltip: this.$t("est.tooltip.E_LoadingFromShore"),
        },
        {
          text: this.$t("est.E_FreeLaying"),
          align: "center",
          value: "freeLaying",
          tooltip: this.$t("est.tooltip.E_FreeLaying"),
        },
        {
          text: this.$t("est.E_SLBJetting"),
          align: "center",
          value: "sLBJetting",
          tooltip: this.$t("est.tooltip.E_SLBJetting"),
        },
        {
          text: this.$t("est.E_SLBTrenching"),
          align: "center",
          value: "sLBTrenching",
          tooltip: this.$t("est.tooltip.E_SLBTrenching"),
        },
        {
          text: this.$t("est.E_LayingWithCIS"),
          align: "center",
          value: "layingWithCIS",
          tooltip: this.$t("est.tooltip.E_LayingWithCIS"),
        },
        {
          text: this.$t("est.E_SailingLoaded "),
          align: "center",
          value: "sailingLoaded",
          tooltip: this.$t("est.tooltip.E_SailingLoaded"),
        },
        {
          text: this.$t("est.E_PostLayingBurialJetting"),
          align: "center",
          value: "pLBurialJetting",
          tooltip: this.$t("est.tooltip.E_PostLayingBurialJetting"),
        },
        {
          text: this.$t("est.E_PostLayingBurialTrenching"),
          align: "center",
          value: "pLBurialTrenching",
          tooltip: this.$t("est.tooltip.E_PostLayingBurialTrenching"),
        },
        {
          text: this.$t("est.E_MassFlowExcavation"),
          align: "center",
          value: "massFlowExcavation",
          tooltip: this.$t("est.tooltip.E_MassFlowExcavation"),
        },
        {
          text: this.$t("est.E_ConcreteMattressesInstallation"),
          align: "center",
          value: "concreteMattInstallation",
          tooltip: this.$t("est.tooltip.E_ConcreteMattressesInstallation"),
        },
        { text: this.$t("est.E_ROVOps"), align: "center", value: "rOVOps", tooltip: this.$t("est.tooltip.E_ROVOps") },
        {
          text: this.$t("est.E_Pretrenching"),
          align: "center",
          value: "pretrenching",
          tooltip: this.$t("est.tooltip.E_Pretrenching"),
        },
        {
          text: this.$t("est.E_Backfilling"),
          align: "center",
          value: "backfilling",
          tooltip: this.$t("est.tooltip.E_Backfilling"),
        },
        {
          text: this.$t("est.E_BoulderClerance"),
          align: "center",
          value: "boulderClerance",
          tooltip: this.$t("est.tooltip.E_BoulderClerance"),
        },
        { text: this.$t("est.E_PLGR"), align: "center", value: "pLGR", tooltip: this.$t("est.tooltip.E_PLGR") },
        {
          text: this.$t("est.E_RouteClearance"),
          align: "center",
          value: "routeClearance",
          tooltip: this.$t("est.tooltip.E_RouteClearance"),
        },
        {
          text: this.$t("est.E_SeaTrials"),
          align: "center",
          value: "seaTrials",
          tooltip: this.$t("est.tooltip.E_SeaTrials"),
        },
        {
          text: this.$t("est.E_PLBJetting2"),
          align: "center",
          value: "pLBJetting2",
          tooltip: this.$t("est.tooltip.E_PLBJetting2"),
        },
        {
          text: this.$t("est.E_PLBJetting3"),
          align: "center",
          value: "pLBJetting3",
          tooltip: this.$t("est.tooltip.E_PLBJetting3"),
        },
        { text: this.$t("est.E_Landing"), align: "center", value: "landing", tooltip: this.$t("est.tooltip.E_Landing") },
        {
          text: this.$t("est.E_CableTesting"),
          align: "center",
          value: "cableTesting",
          tooltip: this.$t("est.tooltip.E_CableTesting"),
        },
        { text: this.$t("est.E_Jointing"), align: "center", value: "jointing", tooltip: this.$t("est.tooltip.E_Jointing") },
        { text: this.$t("est.E_OthersOP"), align: "center", value: "othersOP", tooltip: this.$t("est.tooltip.E_OthersOP") },
        {
          text: this.$t("est.FuelConsumption"),
          align: "center",
          value: "fuelCons",
          tooltip: this.$t("est.tooltip.FuelConsumption"),
        },
        {
          text: this.$t("est.OilConsumption"),
          align: "center",
          value: "OilCons",
          tooltip: this.$t("est.tooltip.OilConsumption"),
        },
        {
          text: this.$t("est.FWConsumption"),
          align: "center",
          value: "FWCons",
          tooltip: this.$t("est.tooltip.FWConsumption"),
        },
        {
          text: this.$t("common.projectName"),
          align: "left",
          value: "projectId",
        },
        {
          text: this.$t("common.asset"),
          align: "left",
          value: "vesselId",
        },
        {
          text: this.$t("column.actions"),
          align: "center",
          value: "estimatesactions",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null,

      panel: [0],
    };
  },
  computed: {
    ...mapGetters(["m_estimate/getNextSeqCode", "m_estimate/getEstimates", "m_project/getProjectNames", "m_project/getProjectsMap", "m_project/getProjectVesselIds", "m_vessel/getVesselNames", "m_vessel/getVesselsMap", "m_passet/getSelProjectId", "m_passet/getSelVesselId", "m_passet/getSelProjectVesselIds"]),
    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.new") + " " + this.$t("est.estimate") : this.$t("common.edit") + " " + this.$t("est.estimate");
    },

    items() {
      return this["m_estimate/getEstimates"];
    },

    projects() {
      return this["m_project/getProjectNames"].filter((p) => p.VCount > 0);
    },

    projectsMap() {
      return this["m_project/getProjectsMap"];
    },

    vessels() {
      return this["m_vessel/getVesselNames"];
    },

    vesselsMap() {
      return this["m_vessel/getVesselsMap"];
    },

    projectVessels() {
      let vessels = this.vessels;

      let pvIds = this["m_passet/getSelProjectVesselIds"];
      if (this.dlgSelProjectId) {
        pvIds = this["m_project/getProjectVesselIds"];
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1);
    },

    formIsValid() {
      return this.editedItem.estimateID && this.editedItem.description && this.editedItem.projectId && this.editedItem.vesselId;
    },
  },
  watch: {
    dialogTabs(val) {
      val || this.close();
    },
  },

  filters: {
    projectName: function(pId, map) {
      return pId ? map[pId] : "";
    },
    vesselName: function(vId, map) {
      return vId ? map[vId] : "";
    },
  },

  created() {
    this.selProjectId = this["m_passet/getSelProjectId"];
    this.selVesselId = this["m_passet/getSelVesselId"];

    this.$log.debug("loading estimates for", this.selProjectId, this.selVesselId);
    this.refreshEstimates();
    this.refreshNextSeqCode();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapMutations(["mHideLongLoader"]),
    ...mapActions(["m_estimate/createEstimate", "m_estimate/fetchEstimates", "m_estimate/updateEstimate", "m_estimate/deleteEstimate", "m_estimate/fetchNextMaxCode", "m_project/fetchProjectVesselNames"]),

    refreshEstimates() {
      this["m_estimate/fetchEstimates"]({
        pId: this.selProjectId,
        vId: this.selVesselId,
      });
    },

    onProjectChange(value) {
      this.selProjectId = value;
      this.refreshEstimates();
    },

    onVesselChange(value) {
      this.selVesselId = value;
      this.refreshEstimates();
    },

    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId;
      this.$log.debug("dlg project change", this.dlgSelProjectId);
      this["m_project/fetchProjectVesselNames"](this.dlgSelProjectId);
      this.refreshNextSeqCode();
    },

    onDlgVesselChange() {
      this.$log.debug("dlg vessel changed", this.editedItem.vesselId);
      if (!this.editedItem.projectId || !this.editedItem.vesselId) {
        return;
      }

      this.refreshNextSeqCode();
    },

    refreshNextSeqCode(useDefVal) {
      if (this.editedIndex > -1) {
        return false;
      }

      let pId = useDefVal ? this.selProjectId : this.editedItem.projectId;
      let vId = useDefVal ? this.selVesselId : this.editedItem.vesselId;

      this["m_estimate/fetchNextMaxCode"]({
        pId: pId,
        vId: vId,
      }).then((nextCode) => {
        this.editedItem.estimateID = nextCode;
        this.$nextTick(() => this.$forceUpdate());
      });
    },

    resetEntity(item) {
      this.dlgSelProjectId = null;
      this["m_project/fetchProjectVesselNames"](this.dlgSelProjectId);

      this.defaultItem.projectId = this["m_passet/getSelProjectId"];
      this.defaultItem.vesselId = this["m_passet/getSelVesselId"];

      this.editedIndex = item ? this.items.indexOf(item) : -1;
      this.editedItem = Object.assign({}, item || this.defaultItem);
    },

    editItem(item) {
      this.resetEntity(item);
      this.onDlgProjectChange();
      this.dialogTabs = true;
    },
    createItemDTabs() {
      this.resetEntity();

      if (this.defaultItem.projectId != null && this.defaultItem.selVesselId) {
        this.onDlgVesselChange();
      }

      this.refreshNextSeqCode();
      this.editedItem.estimateID = this["m_estimate/getNextSeqCode"];
      this.dialogTabs = true;
    },
    deleteItemConfirm(item) {
      this.resetEntity(item);

      var msg = this.editedItem.isDeleted ? "warming.unlock" : "warming.lock";
      this.$confirm(this.$t(msg) + this.$t("est.estimate").toLowerCase() + "?", {
        buttonTrueText: this.$t("common.ok"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((res) => res && this["m_estimate/deleteEstimate"](this.editedItem).then(this.refreshEstimates));
    },
    close() {
      this.$refs.form.resetValidation();
      this.dialogTabs = false;
    },
    save() {
      if (~this.editedIndex) {
        this["m_estimate/updateEstimate"](this.editedItem).then(this.refreshEstimates);
      }

      if (!~this.editedIndex) {
        this["m_estimate/createEstimate"](this.editedItem).then(this.refreshEstimates);
      }

      this.close();
    },
  },
};
</script>

<style>
#estimateTable {
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  width: auto;
  height: auto;
}
#estimateTable header {
  font-weight: bold;
}
#estimatesCard {
  width: auto;
}
</style>
